<template>
  <div>
    <!-- サービス概要 -->
    <Description :service="service" />

    <OneColumnPageLayout>
      <h2 class="text-accent">
        {{ $t('Service.AssignedUsers') }}
      </h2>
      <v-container>
        <ServiceUserList
          :filter-services="[serviceId]"
          class="mb-5"
        />
      </v-container>
      <!--      <service-payment-content :service="service" v-if="is_admin"/>-->
    </OneColumnPageLayout>
  </div>
</template>

<script>
  import ServiceMixin from '../ServiceMixin'
  import Description from './Description'
  import ServiceUserList from '@/components/content/ServiceUserList'
  import OutSideTitleCard from '@/components/parts/card/OutSideTitleCard'
  import OneColumnPageLayout
    from '@/components/pages/layouts/OneColumnPageLayout'

  export default {
    components: {
      OneColumnPageLayout,
      ServiceUserList,
      Description
    },
    mixins: [ServiceMixin],
    props: {},
    data: () => ({
      serviceId: 'remoterack'
    }),
    created () {
      this.getServiceDetail()
    },
    mounted () {}
  }
</script>
